export default {
  v3OfficialTopUpCenterTitle: 'Centro oficial de recargas',
  v3OfficialTopUpCenterKeyword: 'Centro oficial de recargas',
  v3OfficialTopUpCenterDescription: 'Centro oficial de recargas',
  v3SafeAndFast: 'Seguro, sin riesgos y se acredita al instante',
  v3Shop: 'Centro comercial',
  v3ShoppingCart: 'Carrito de compras',
  v3MembershipCenter: 'Centro de privilegios (Centro de miembros premium)',
  v3Login: 'Iniciar sesión',
  v3Account: 'Cuenta',
  v3EnterAccountName: 'Ingresar nombre de la cuenta',
  v3Password: 'Contraseña',
  v3EnterPassword: 'Ingresar contraseña',
  v3ForgotPassword: 'Olvidé la contraseña',
  v3EnterUID: 'Ingresar ID de usuario',
  v3OTP: 'OTP',
  v3EnterOTP: 'Ingresa el OTP',
  v3SelectTopUpCharacter: 'Selecciona el personaje de la recarga',
  v3SelectServer: 'Selecciona el servidor',
  v3Confirm: 'Confirmar',
  v3CharacterNotFound:
    'Si no encuentras al personaje, intenta primero conectarte al juego con el personaje y, luego, ve a la página de recarga, o ponte en contacto con el servicio técnico.',
  v3Logout: 'Cerrar sesión',
  v3SwitchAccount: 'Cambiar cuenta',
  v3MyCoupons: 'Mis cupones',
  v3BenefitsCenter: 'Centro de miembros premium',
  v3TopUpBenefits: 'Beneficios de la recarga',
  v3MoreSettings: 'Más ajustes',
  v3RememberLoginStatus: 'Recuerda mi estado de acceso',
  v3OrderQuery: 'Ver pedidos',
  v3ContactCustomerService: 'Atención al cliente',
  v3LoginWithApp: 'Accede con la aplicación',
  v3ChooseOtherLoginMethod:
    'Selecciona un método de inicio de sesión alternativo',
  v3ConnectingToGameApp: 'Conectándose a la aplicación del juego',
  v3EnsureGameInstalled:
    'Asegúrate de que el juego está instalado en este dispositivo. Si el juego no responde o el inicio de sesión falla, descarga la última versión desde la tienda de aplicaciones o usa otro navegador.',
  v3OpenGame: 'Iniciar juego',
  v3DownloadGame: 'Descargar juego',
  v3UpdateGameIfOpenFails:
    'Si el juego no se inicia, descarga e instala la última versión desde la App Store/Google Play.',
  v3ClickToDownloadLatestVersion:
    'También puedes pulsar el botón de descarga del juego para obtener la última versión.',
  v3LoggingIntoOfficialTopUpCenter:
    'Estás ingresando al [Centro oficial de recargas]',
  v3CurrentAccount: 'Cuenta actual: xxxxxxxxxx',
  v3WelcomeToOfficialTopUpCenter:
    'Te damos la bienvenida al Centro oficial de recargas',
  v3OfficialAuthorizedLogin:
    'Inicio de sesión oficialmente autorizado. No existen riesgos de seguridad.',
  v3TermsOfService: 'Términos del servicio',
  v3PrivacyPolicy: 'Política de privacidad',
  v3ThirdPartySocialAccountDescription:
    'Sobre las cuentas externas en redes sociales',
  v3BindSocialAccountInGameFirst:
    'Primero, vincula la cuenta de tus redes sociales al Centro de usuario del juego y, luego, inicia sesión con la cuenta que hayas vinculado.',
  v3FirstTopUp15PercentOff:
    'Disfruta de hasta un 15% de DESCUENTO en tu primera recarga',
  v3MoreTopUpRebates: 'Más bonificaciones y recompensas',
  v3LoginToViewOffers: 'Conéctate para ver los descuentos',
  v3TopUpEnvironmentChecking: 'Verificando el medio de recarga...',
  v3SafeToUse: 'Seguro y protegido.',
  v3LimitedTimeBenefits: 'Oferta exclusiva por tiempo limitado',
  v3EventRules: 'Reglas del evento',
  v3MoreEvents: 'Más eventos',
  v3Claim: 'Reclamar',
  v3Completed: 'Completado',
  v3GoTo: 'Ir',
  v3ViewDetails: 'Ver detalles',
  v3RecommendedProducts: 'Objetos recomendados',
  v3SearchProductName: 'Buscar por nombre del objeto',
  v3AllCategories: 'Todo',
  v3PopularSort: 'Lo mejor',
  v3PriceAscending: 'Precio ↑',
  v3PriceDescending: 'Precio ↓',
  v3DiamondBonus10Percent: 'Diamante +10%',
  v3YuanbaoBonus10Percent: 'Lingote +10%',
  v3ExtraBonus10Percent: 'Bonificación: 10%',
  v3FirstTopUpDouble: '1ª recarga doble',
  v3FirstExtraBonus: 'Bonificación por 1ª vez',
  v3ProductDetails: 'Detalles del producto',
  v3AddToCart: 'Agregar al carro',
  v3AddedToCart: 'Agregado al carro',
  v3BuyNow: 'Comprar ahora',
  v3NoItemsInCart: 'Aún no hay artículos en tu carro',
  v3SelectedItemsN: 'Artículos seleccionados: (${n})',
  v3RemoveFromCart: '¿Eliminar del carro?',
  v3Yes: 'Sí',
  v3No: 'No',
  v3LimitOnePerPurchase:
    'Solo se puede comprar uno de estos artículos a la vez',
  v3ItemPrice: 'Premio del objeto',
  v3Tax: 'Impuesto',
  v3TaxNotIncluded: 'Impuesto no incluido',
  v3TaxIncluded: 'Impuesto incluido (${tax})',
  v3ExtraGift: 'Bonificación',
  v3Total: 'Total',
  v3ProceedToPayment: 'Pagar',
  v3SelectCoupon: 'Seleccionar cupón',
  v3UnavailableCoupons: 'Cupones no disponibles',
  v3OneCouponPerOrder: 'Un cupón por pedido',
  v3DiscountCoupon: 'Cupón de descuento',
  v3ThresholdCoupon: 'Cupón de deducción',
  v3MinSpendCoupon: 'Se puede usar cuando el precio total supera los xx USD',
  v3MaxDiscountCoupon: 'Descuento de hasta xxxx USD',
  v3LimitedChannel: 'Limitado a canales específicos',
  v3AllChannels: 'Disponible para todos los canales',
  v3SpecificProducts: 'Solo artículos específicos',
  v3AllProducts: 'Para todos los artículos',
  v3NotYetTimeToUse: 'No se puede usar todavía',
  v3Expired: 'Vencido',
  v3Used: 'Usado',
  v3ValidityPeriod: 'Validez: ',
  v3ConfirmUse: 'Confirmar',
  v3ChangeProduct: 'Cambiar artículo',
  v3ConfirmPaymentOrder: 'Confirmar pedido',
  v3StoredValueRole: 'Personaje de recarga',
  v3TotalNProducts: 'Total de artículos: ${n}',
  v3SelectPaymentMethod: 'Elegir método de pago',
  v3PayNow: 'Pagar ahora',
  v3MorePaymentMethods: 'Más métodos de pago',
  v3NoAvailablePaymentMethodContactSupport:
    '¿No ves ningún método de pago disponible? Contacta al servicio técnico.',
  v3AvailableCoupons: 'Cupones para usar',
  v3Extra10Percent: '0.1',
  v3LastSelection: 'Elección anterior',
  v3RecommendedUsage: 'Recomendado',
  v3PopularChoice: 'Elección popular',
  v3PaymentSuccess: 'Pago realizado',
  v3PaymentFailure: 'No se pudo realizar el pago',
  v3TopUpFailureMessage:
    'Lo sentimos, pero la recarga falló. Realiza el pedido de nuevo o ponte en contacto con el servicio técnico.',
  v3Game: 'Juego',
  v3UID: 'ID de usuario',
  v3OrderNumber: 'N.° de pedido',
  v3ProductContent: 'Detalles del artículo',
  v3ViewProductDetails: 'Ver detalles del artículo',
  v3PaymentMethod: 'Método de pago',
  v3Complete: 'Completar',
  v3TopUpAgain: 'Recarga de nuevo',
  v3FriendlyReminderSaveOrderInfo:
    'Recordatorio: Haz una captura de pantalla de tu pedido para procesarla más rápido.',
  v3RechargeAgain: 'Recarga de nuevo',
  v3TransactionInProgress: 'Procesando la transacción',
  v3CompletePaymentInChannel:
    'Dirígete al canal de pago para completar el pago.',
  v3RestAssuredFastDeliveryAfterPayment:
    'Recibirás el artículo una vez se haya efectuado el pago.',
  v3SaveOrderInfoForProgress:
    'Toma una captura de pantalla de tu pedido para seguir el progreso de la transacción.',
  v3PaymentCompleted: 'Se ha completado el pago',
  v3AddToHomeScreen: 'Añadir a la pantalla de inicio',
  v3AddShortcutForBonus:
    'Añade un acceso directo para recibir recompensas extras',
  v3ShareSuccess: 'Compartido',
  v3ShareFailure: 'No se pudo compartir',
  v3RewardClaimed: 'Recompensa reclamada',
  v3RewardClaimFailed: 'No se pudo reclamar la recompensa',
  v3EventNotStarted: 'El evento aún no ha comenzado',
  v3EventEnded: 'El evento ha finalizado',
  v3ClickSelectCoupon: 'Haga clic para seleccionar el cupón',
  v3CouponsRecommendedUsed: 'Cupón recomendado utilizado',
  v3CouponsSelected: 'Cupón seleccionado',
  v3NoCouponsAvaliable: 'No hay cupones disponibles',
  v3SupplementStatus: 'Estado',
  v3SupplementNormal: 'Normal',
  v3SupplementBanned: 'Prohibido',
  v3SupplementPendingPayment: 'Pago Pendiente',
  v3SupplementSwitchCharacter: 'Cambiar Personaje',
  v3SupplementAccountInfoInvalid: 'Información de la Cuenta Inválida',
  v3SupplementContactGSForTopUpLink:
    'Por favor, contacte a GS para obtener el enlace de recarga',
  v3SupplementTopUpCompleted: 'Recarga Completada:',
  v3SupplementTotalRefundOrders: 'Total de Órdenes de Reembolso: {}',
  v3SupplementPendingSupplementAmount: 'Monto de Pago Pendiente:',
  v3SupplementAccountCharacterNormalNoPaymentNeeded:
    'Cuenta/Personaje Normal, no se necesita pago',
  v3SupplementEnjoyYourGame: '¡Disfruta tu juego!',
  v3SupplementOrderInformation: 'Información del pedido',
  v3SupplementPendingPaymentAmount: 'Cantidad pendiente de pago:',
  v3LookUpCouponRule: 'Lee las reglas de distribución de cupones',
  v3SwitchOldVersion: 'Cambiar a la antigua plataforma de pago',
  v3FirstTopUpGiveaway: 'Bonificación de 1.ª recarga',
  v3SecureConnection: 'Estableciendo conexión segura',
  v3RequestTimeOut:
    'Se agotó el tiempo de carga, inténtalo de nuevo más tarde.',
  v3ConfirmLeave: '¿Salir?',
  v3NoSubmitOrder:
    'Aún no has finalizado tu compra. Si te vas, podrías perder los artículos deseados.',
  v3ContinueSubmit: 'Continuar',
  v3LeaveSubmit: 'Salir',
  v3RecentBug: 'Compras recientes',
  v3ScanCodeLogin: 'Scan Code Login',
  v3BindRole: 'Bind Role',
  v3ScanLoading: 'loading...',
  v3ScanExpired: 'QR code expired',
  v3ScanRefreshClick: 'Click to refresh',
  v3ScanRefreshTip: 'Please refresh and scan again',
  v3ScanRefresh: 'Refresh',
  v3ScanSucc: 'Scanned successfully',
  v3ScanAuth: 'Please confirm on your phone',
  v3ScanAuthSuccess: 'Authorization successful',
  v3ScanAuthSuccessTip: 'Logging in...',
  v3ScanUnauthorized: 'Authorization failed',
  v3ScanRefreshTip2: 'Log in to the game app to scan',
  v3ScanGuide: 'Scan Guide',
  v3ScanLoginError: 'Login error, please refresh and retry',
  v3ThirdPartyLogin: 'Third-party Login',
  v3NoMyLoginMethod: "Don't have my login method?",
  v3AccountPasswordLogin: 'Please enter account to bind game character',
  v3PwaTapShareOrMenuIcon: 'Pulsa el icono Compartir o Menú en la barra de herramientas del navegador',
  v3PwaFindAndTapAddToHomeScreen: 'Busca y pulsa "Añadir a la pantalla de inicio" en las opciones',
  v3LaunchFromDesktopAndRewardToMailbox: 'Por favor, inicie desde el escritorio\nSeleccione un personaje y la recompensa se enviará al buzón',
  v3ClaimSuccessCheckMailbox: 'Reclamado con éxito\nPor favor, revisa tu correo del juego',
  v3ProductLimitOnceBadge: 'ÚNICO',
  v3ProductWeeklyOnlyBadge: 'SEMANAL',
  v3ProductMonthlyOnlyBadge: 'MENSUAL',
  v3ProductWebExclusiveBadge: 'Exclusivo Web',
  v3CartMutexProductTip: 'Este producto no se puede agregar al carrito por ahora.\nVacíe el carrito antes de comprar.',
  v3ProductDiscountBadge: '**% DESCUENTO',
};
